export const ITipPayloadRepositoryType = Symbol('ITipPayloadRepository');
